import { cn } from "@/lib/utils";

interface SectionHeaderProps {
  badge?: string;
  title: string;
  description?: string;
  align?: "left" | "center";
  className?: string;
  as?: "h1" | "h2";
}

export function SectionHeader({ badge, title, description, align = "center", className, as = "h2" }: SectionHeaderProps) {
  const Heading = as;
  return (
    <div
      className={cn(
        "max-w-3xl",
        align === "center" && "mx-auto text-center",
        className
      )}
    >
      {badge && (
        <span className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-accent text-accent-foreground mb-4">
          {badge}
        </span>
      )}
      <Heading className="text-2xl sm:text-3xl md:text-4xl font-bold text-foreground mb-3 md:mb-4 text-balance">{title}</Heading>
      {description && (
        <p className="text-base md:text-lg text-muted-foreground text-balance">{description}</p>
      )}
    </div>
  );
}
